<template>
  <v-card class="rounded-lg pa-2 white  pb-8" flat>
    <v-card-title class="secondary--text">درصد حاشیه سود
      <v-spacer></v-spacer>
      <chart-export-btn page-chart-id="profit-margin-percent-chart"></chart-export-btn>

    </v-card-title>

    <div
        class="secondary--text font-weight-bold"
        style="width: 115%; height: 40px; position: absolute; top: 50%; left: 0; margin-top: auto; line-height:19px; text-align: center; z-index: 999999999999999">
      درصد حاشیه سود
      <br/>
      <span style="font-size: small" class="grey--text"> هشت کالا برتر</span>

    </div>
    <canvas height="100" id="profit-margin-percent-chart">

    </canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";
export default {
  name: 'ProfitMarginPercentChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartData: {
        type: "doughnut",
        data: {
          labels: ["کالا یک", "کالا دو", "کالا سه", "کالا چهار", "کالا پنج", "کالا شش", "کالا هفت", "کالا هشت"],
          datasets: [
            {
              data: [35, 25, 15, 10, 8, 7, 19, 20],
              backgroundColor: ["#43CED7", "#50CC89", "#FFC700", "#F1416C", '#7239E9', '#019EF6' , '#FF8700', '#002357' ],
              borderWidth: 3,
              hoverBorderWidth:5,
              hoverBorderColor: '#FFFFFF',
            },
          ]
        },
        options: {
          legend: {
            position: 'left'
          },
          cutoutPercentage: 70,
          responsive: true,
          plugins: {
            legend: {

              position: 'top',
            },
          }
        }
      },
    }
  },
  mounted() {
    const ctx = document.getElementById('profit-margin-percent-chart');
    new Chart(ctx, this.chartData);
  }
}
</script>